/**
 * @generated SignedSource<<4e1cc49284b754afb5911379f1b5d0d0>>
 * @relayHash d7ed975d357c90fe0b2b7af56d44be0b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f6849648240760c1a4e22938e1a11922b2177cf7f644bc6fe1c9cf6ef6e5aabd

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavPlansQuery } from './HorizontalNavPlansQuery.graphql';

const node: PreloadableConcreteRequest<HorizontalNavPlansQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f6849648240760c1a4e22938e1a11922b2177cf7f644bc6fe1c9cf6ef6e5aabd",
    "metadata": {},
    "name": "HorizontalNavPlansQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
